/**
 * Original wave geometry from git (viewBox 0 0 1440 160, bottom strip).
 * Fill below curve: M0,80 C240,160 480,160 720,80 C960,0 1200,0 1440,80 …
 * Mask keeps image above that curve (white = visible).
 */
const HERO_MASK_HEIGHT = 1000;
const WAVE_STRIP_HEIGHT = 160;
const WAVE_STRIP_TOP = HERO_MASK_HEIGHT - WAVE_STRIP_HEIGHT;
/** Overlap rect into wave strip so rasterized mask has no 1px seam at y=WAVE_STRIP_TOP. */
const MASK_BLEED = 2;

const HERO_WAVE_MASK_SVG =
    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 " + HERO_MASK_HEIGHT + "' preserveAspectRatio='none'>" +
    "<rect width='1440' height='" + (WAVE_STRIP_TOP + MASK_BLEED) + "' fill='white'/>" +
    "<path fill='white' d='M0," + WAVE_STRIP_TOP + " H1440 V" + (WAVE_STRIP_TOP + 80) +
    " C1200," + WAVE_STRIP_TOP + " 960," + WAVE_STRIP_TOP + " 720," + (WAVE_STRIP_TOP + 80) +
    " C480," + HERO_MASK_HEIGHT + " 240," + HERO_MASK_HEIGHT + " 0," + (WAVE_STRIP_TOP + 80) + " Z'/>" +
    "</svg>";

export const heroWaveMaskImage = `url("data:image/svg+xml,${encodeURIComponent(HERO_WAVE_MASK_SVG)}")`;

export const heroWaveMaskStyles = {
    WebkitMaskImage: heroWaveMaskImage,
    maskImage: heroWaveMaskImage,
    WebkitMaskSize: "100% 100%",
    maskSize: "100% 100%",
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
} as const;
